/**
 * AMAÇ: React uygulamasının giriş noktası — App'i #root elemanına bağlar
 */
import './utils/trustedTypes.js' // her şeyden önce: sink'lere dokunulmadan policy kayıtlı olmalı
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import './utils/loadFont.js'
import { initGoogleAnalytics } from './utils/googleAnalytics.js'
import './utils/utm.js'
import App from './App.jsx'

// Fonksiyon çağrısı olarak (import-time yan etkisi değil) — bkz. googleAnalytics.js'teki
// yorum: trustedTypes policy'sinin kayıtlı OLDUĞUNDAN emin olmanın tek güvenilir yolu bu.
initGoogleAnalytics()

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
